var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"f-select-button",class:[_vm.classes, _vm.btnClass]},[_vm._t("default"),_c('span',{staticClass:"arrow"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }